import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { db, auth } from "../../../../../../firebase";
import {
  collection,
  addDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

import SubHeading from "../../../../../../components/common/SubHeading";
import UsefulMessage from "../../../../../../components/common/UsefulMessage";
import WarningMessage from "../../../../../../components/common/WarningMessage";

import { MdOutlineClose, MdAddCircle } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa";

import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  TreeSelect,
} from "antd";

import {
  SelectMoveInTenantInfo,
  setLeaseDetails,
  setLeaseId,
} from "../../../../../../store/moveInTenantSlice";
import { glAccountss } from "../../../../../../data/accounting";
import {
  filterType,
  gracePeriodType,
  lateFeeType,
  moveIns,
} from "../../../../../../utils/tenants";
import { companyNames } from "../../../../../../data/people";

import "./LeaseDetails.css";

const message = (
  <>
    In order to send the insurance email, the primary tenant's email address is
    required on the <span className="onclick-text">Profile</span> tab.
  </>
);

function LeaseDetails({ current, setCurrent }) {
  const [monthlyCharges, setMonthlyCharges] = useState([
    {
      id: 1,
      amount: "",
      glAccount: "",
      description: "",
      prorateThisCharge: false,
    },
  ]);
  const [moveInCharges, setMoveInCharges] = useState([
    { id: 1, amount: "", glAccount: "", description: "" },
  ]);
  const [proratedCharges, setProratedCharges] = useState([]);
  const [propertyPolicyChecked, setPropertyPolicyChecked] = useState(true);
  const [totalBalanceChecked, setTotalBalanceChecked] = useState(false);
  const [lateFeeChecked, setLateFeeChecked] = useState(false);
  const [mTMChecked, setMTMChecked] = useState(false);
  const [enrollChecked, setEnrollChecked] = useState(true);
  const [adminFeeChecked, setAdminFeeChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);
  const moveInTenantInfo = useSelector(SelectMoveInTenantInfo);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setProratedCharges(monthlyCharges);
  }, [monthlyCharges]);

  let monthlyChargesSum = 0;
  for (let i = 0; i < monthlyCharges.length; i++) {
    if (monthlyCharges[i].amount) {
      monthlyChargesSum += parseInt(monthlyCharges[i].amount);
    }
  }
  monthlyChargesSum = parseInt(monthlyChargesSum);

  let proratedChargesSum = 0;
  for (let i = 0; i < proratedCharges.length; i++) {
    if (proratedCharges[i].amount) {
      proratedChargesSum += parseInt(proratedCharges[i].amount);
    }
  }
  proratedChargesSum = parseInt(proratedChargesSum);

  let moveInChargesSum = 0;
  for (let i = 0; i < moveInCharges.length; i++) {
    if (moveInCharges[i].amount) {
      moveInChargesSum += parseInt(moveInCharges[i].amount);
    }
  }
  moveInChargesSum = parseInt(moveInChargesSum);

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };

  const addMonthlyCharge = () => {
    const newMonthlyCharge = {
      id: monthlyCharges.length + 1,
      amount: "",
      glAccount: "",
      description: "",
      prorateThisCharge: false,
    };
    setMonthlyCharges([...monthlyCharges, newMonthlyCharge]);
    dispatch(
      setLeaseDetails({
        ...moveInTenantInfo.leaseDetails,
        monthlyCharges: monthlyCharges,
      })
    );
  };

  const removeMonthlyCharge = (id) => {
    const updatedMonthlyCharges = monthlyCharges.filter(
      (monthlyCharge) => monthlyCharge.id !== id
    );
    setMonthlyCharges(updatedMonthlyCharges);
  };

  const handleSelectChange = (value, id) => {
    const updatedMonthlyCharges = monthlyCharges.map((monthlyCharge) => {
      if (monthlyCharge.id === id) {
        return { ...monthlyCharge, glAccount: value };
      }
      return monthlyCharge;
    });
    setMonthlyCharges(updatedMonthlyCharges);
  };

  const onInputChange = (e, id, name) => {
    const updatedMonthlyCharges = monthlyCharges.map((monthlyCharge) => {
      if (monthlyCharge.id === id) {
        return { ...monthlyCharge, [name]: e.target.value };
      }
      return monthlyCharge;
    });
    setMonthlyCharges(updatedMonthlyCharges);
  };

  const addMoveInCharge = () => {
    const newMoveInCharge = {
      id: moveInCharges.length + 1,
      amount: "",
      glAccount: "",
      description: "",
    };
    setMoveInCharges([...moveInCharges, newMoveInCharge]);
  };

  const removeMoveInCharge = (id) => {
    const updatedMoveInCharges = moveInCharges.filter(
      (moveInCharge) => moveInCharge.id !== id
    );
    setMoveInCharges(updatedMoveInCharges);
  };

  const handleAccountChange = (value, id) => {
    const updatedMoveInCharges = moveInCharges.map((moveInCharge) => {
      if (moveInCharge.id === id) {
        return { ...moveInCharge, glAccount: value };
      }
      return moveInCharge;
    });
    setMoveInCharges(updatedMoveInCharges);
  };

  const handleInputChange = (e, id, name) => {
    const updatedMoveInCharges = moveInCharges.map((moveInCharge) => {
      if (moveInCharge.id === id) {
        return { ...moveInCharge, [name]: e.target.value };
      }
      return moveInCharge;
    });
    setMoveInCharges(updatedMoveInCharges);
  };

  const handleCheckboxChange = (id) => {
    const updatedCharges = monthlyCharges.map((charge) => {
      if (charge.id === id) {
        return { ...charge, prorateThisCharge: !charge.prorateThisCharge };
      }
      return charge;
    });
    setMonthlyCharges(updatedCharges);
  };

  const handleFormSubmit = async (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    values.monthToMonth = mTMChecked;
    values.enroll = enrollChecked;
    values.propertyPolicy = propertyPolicyChecked;
    console.log(values.monthToMonth);
    const leaseDates = {
      moveInDate: values.moveInDate.format("YYYY-MM-DD"),
      leaseStartDate: values.leaseStartDate.format("YYYY-MM-DD"),
      leaseEndDate: "",
    };
    const rentersInsurance = {
      moveIn: values.moveIn,
    };

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const leaseRef = collection(companyDocRef, "leases");
    const tenantRef = doc(
      db,
      "companies",
      companyName,
      "tenants",
      moveInTenantInfo.tenantId
    );

    const tenantUpdate = {
      "leaseInformation.endDate": values.leaseEndDate ? values.leaseEndDate.format("YYYY-MM-DD") : "",
      "leaseInformation.insuranceRequirement": "",
      "leaseInformation.monthToMonth": values.monthToMonth,
      "leaseInformation.renewelDate": "",
      "leaseInformation.signedDate": "",
      "leaseInformation.startDate": values.leaseStartDate.format("YYYY-MM-DD"),
      "lateFeePolicy": values.propertyPolicy
      ? { usePropertyPolicy: true}
      : {
          lateFeeType: values.lateFeeType,
          baseLateFee: values.baseLateFee,
          gracePeriodType: values.gracePeriodType,
          eligibleChargeType: values.eligibleChargeType,
          totalDelinquentBalance: values.totalDelinquentBalance,
          chargeDailyLateFee: values.chargeDailyLateFee,
          dailyLateFee: values.dailyLateFee,
          maxDailyLateFee: values.maxDailyLateFee,
          graceBalance: values.graceBalance,
        },
    };

    try {
      updateDoc(tenantRef, tenantUpdate);
    } catch (err) {
      console.log(err);
    }

   if(!moveInTenantInfo.leaseId){
    try {
      const leaseData = await addDoc(leaseRef, {
        leaseDates: values.monthToMonth
          ? {
              ...leaseDates,
              leaseEndDate: "month to month",
            }
          : {
              ...leaseDates,
              leaseEndDate: values.leaseEndDate
                ? values.leaseEndDate.format("YYYY-MM-DD")
                : "",
            },
        rentersInsurance: values.enroll
          ? {
              ...rentersInsurance,
              monthlyAdminFee: values.monthlyAdminFee,
              adminFee: values.monthlyAdminFee && values.adminFee,
            }
          : {
              ...rentersInsurance,
              compnayName: values.compnayName,
              policyNumber: values.policyNumber,
              policyStartDate: values.policyStartDate
                ? values.policyStartDate.format("YYYY-MM-DD")
                : "",
              policyExpirationDate: values.policyStartDate
                ? values.policyStartDate.format("YYYY-MM-DD")
                : "",
            },
        lateFeePolicy: values.propertyPolicy
          ? "Use property's policy"
          : {
              lateFeeType: values.lateFeeType,
              baseLateFee: values.baseLateFee,
              gracePeriodType: values.gracePeriodType,
              eligibleChargeType: values.eligibleChargeType,
              totalDelinquentBalance: values.totalDelinquentBalance,
              chargeDailyLateFee: values.chargeDailyLateFee,
              dailyLateFee: values.dailyLateFee,
              maxDailyLateFee: values.maxDailyLateFee,
              graceBalance: values.graceBalance,
            },
        moveInCharges: moveInCharges,
        monthlyCharges: monthlyCharges,
        proratedCharges: proratedCharges,
        tenantPaymentSchedule: {
          dueOnceMoveInCompleted: moveInChargesSum,
          dueOnMoveInDate: proratedChargesSum,
          dueMonthlyThereafter: monthlyChargesSum,
        },
        tenantId: moveInTenantInfo.tenantId,
        propertyId: moveInTenantInfo.propertyUnit.id,
      });
      console.log("Tenant created successfully");
      dispatch(setLeaseId(leaseData.id));
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
   }

   if(moveInTenantInfo.leaseId){
    const leaseRef = doc(
      db,
      "companies",
      companyName,
      "leases",
      moveInTenantInfo.leaseId
    );

    getDoc(leaseRef)
      .then((docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          console.log("Document data:", data);
          updateDoc(leaseRef, {
            "leaseDates.leaseStartDate": values.leaseStartDate ? values.leaseStartDate : data.leaseDates.leaseStartDate,
            "leaseDates.moveInDate": values.moveInDate ? values.moveInDate : data.leaseDates.moveInDate,
            "leaseDates.leaseEndDate": values.leaseEndDate ? values.leaseEndDate : data.leaseDates.leaseEndDate,
            "leaseDates.leaseMtMonth": values.leaseMtMonth ? values.leaseMtMonth : data.leaseDates.leaseMtMonth,
            leaseDates: values.monthToMonth
              ? {
                  ...leaseDates,
                  leaseEndDate: "month to month",
                }
              : {
                  ...leaseDates,
                  leaseEndDate: values.leaseEndDate
                    ? values.leaseEndDate.format("YYYY-MM-DD")
                    : "",
                },
            rentersInsurance: values.enroll
              ? {
                  ...rentersInsurance,
                  monthlyAdminFee: values.monthlyAdminFee,
                  adminFee: values.monthlyAdminFee && values.adminFee,
                }
              : {
                  ...rentersInsurance,
                  compnayName: values.compnayName,
                  policyNumber: values.policyNumber,
                  policyStartDate: values.policyStartDate
                    ? values.policyStartDate.format("YYYY-MM-DD")
                    : "",
                  policyExpirationDate: values.policyStartDate
                    ? values.policyStartDate.format("YYYY-MM-DD")
                    : "",
                },
            lateFeePolicy: values.propertyPolicy
              ? "Use property's policy"
              : {
                  lateFeeType: values.lateFeeType,
                  baseLateFee: values.baseLateFee,
                  gracePeriodType: values.gracePeriodType,
                  eligibleChargeType: values.eligibleChargeType,
                  totalDelinquentBalance: values.totalDelinquentBalance,
                  chargeDailyLateFee: values.chargeDailyLateFee,
                  dailyLateFee: values.dailyLateFee,
                  maxDailyLateFee: values.maxDailyLateFee,
                  graceBalance: values.graceBalance,
                },
            moveInCharges: moveInCharges,
            monthlyCharges: monthlyCharges,
            tenantPaymentSchedule: {
              dueOnceMoveInCompleted: moveInChargesSum,
              dueOnMoveInDate: proratedChargesSum,
              dueMonthlyThereafter: monthlyChargesSum,
            },
            tenantId: moveInTenantInfo.tenantId,
            propertyId: moveInTenantInfo.propertyUnit.id,
          });

  
        } else {
          console.log("No such document exists!");
        }
      })
      .catch((error) => {
        console.error("Error retrieving document:", error);
      });
    next();
  }
};
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    lateFeeType: moveInTenantInfo.propertyUnit.LateFeePolicy.lateFeeType,
    baseLateFee: moveInTenantInfo.propertyUnit.LateFeePolicy.baseLateFeeFlat
      ? moveInTenantInfo.propertyUnit.LateFeePolicy.baseLateFeeFlat
      : moveInTenantInfo.propertyUnit.LateFeePolicy.baseLateFeePercent,
    gracePeriodType: moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriod,
    gracePeriodValue:
      moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriod === "after"
        ? moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriodAfterDays
        : moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriodOnday,
    eligibleChargeType:
      moveInTenantInfo.propertyUnit.LateFeePolicy.eligibleCharges,
  };

  return (
    <div className="lease-details">
      <SubHeading
        subHeading={`Lease Details for ${moveInTenantInfo.profileInfo.firstName} ${moveInTenantInfo.profileInfo.lastName}`}
      />
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <WarningMessage message="A screening report is not detected for this tenant." />
        </Col>
        <Col span={24}>
          <Form
            layout="vertical"
            className="lease-details-container"
            onFinish={handleFormSubmit}
            onFinishFailed={onFinishFailed}
            initialValues={initialValues}
          >
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <p>Lease Dates</p>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Move-In Date"
                  required
                  name="moveInDate"
                  rules={[
                    { required: true, message: "Move in date is required" },
                  ]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Lease Start Date"
                  required
                  name="leaseStartDate"
                  rules={[
                    { required: true, message: "lease start date is required" },
                  ]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="monthToMonth">
                  <Checkbox
                    checked={mTMChecked}
                    onChange={() => setMTMChecked(!mTMChecked)}
                    value={mTMChecked}
                  >
                    Month to Month
                  </Checkbox>
                </Form.Item>
              </Col>
              {mTMChecked ? null : (
                <Col span={24}>
                  <Form.Item label="Lease End Date" name="leaseEndDate">
                    <DatePicker />
                  </Form.Item>
                </Col>
              )}
              <Col span={24}>
                <p>
                  A lease fee bill, dated to match lease start date, will be
                  created once move in is complete
                </p>
              </Col>
              <Col span={24}>
                <WarningMessage message={message} />
              </Col>
            </Row>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <p>Renters Insurance</p>
              </Col>
              <Col span={24}>
                <Form.Item>
                  <Checkbox disabled>
                    Send email to {moveInTenantInfo.firstName}{" "}
                    {moveInTenantInfo.lastName} about renters insurance
                  </Checkbox>
                  <span className="onclick-text">Preview Email</span>
                </Form.Item>
              </Col>
              <Col span={24}>
                <p className="onclick-text">Preview and Send Text Message</p>
              </Col>
              <Col span={24}>
                <Form.Item>
                  <Checkbox disabled checked={true}>
                    FolioGuard Policy Additional Interest
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={24} className="inputs">
                <Form.Item label="Interested Party" required>
                  <Input disabled placeholder="Integrity Oklahoma LLC" />
                </Form.Item>
              </Col>
              <Col span={24} className="inputs">
                <Form.Item label="Contact Email" required>
                  <Input
                    disabled
                    placeholder="Rhett Tullis | President | rhett@integrityokc.com"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <p className="onclick-text">FolioGuard Smart Ensure</p>
              </Col>
              <Col span={24}>
                <UsefulMessage message="Save time and reduce gaps in insurance coverage with Smart Enrollment.">
                  <span className="onclick-text">Learn More</span>
                </UsefulMessage>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={2}>
                    <Form.Item name="enroll">
                      <Checkbox
                        checked={enrollChecked}
                        onChange={() => setEnrollChecked(!enrollChecked)}
                      >
                        Enroll
                      </Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item name="moveIn">
                      <Select options={moveIns} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              {enrollChecked ? (
                <Col span={24}>
                  <Form.Item name="monthlyAdminFee" valuePropName="checked">
                    <Checkbox
                      checked={adminFeeChecked}
                      onChange={() => setAdminFeeChecked(!adminFeeChecked)}
                    >
                      Monthly admin fee
                    </Checkbox>
                  </Form.Item>
                  {adminFeeChecked ? (
                    <Form.Item
                      label="Fee Amount"
                      name="adminFee"
                      rules={[
                        { required: true, message: "admin Fee required" },
                      ]}
                    >
                      <Space>
                        <InputNumber
                          addonBefore={<FaDollarSign size={12} />}
                          placeholder="Enter a charge between $0.01 - $3.00"
                        />
                      </Space>
                    </Form.Item>
                  ) : null}
                </Col>
              ) : (
                <Col span={24} className="enroll">
                  <Row gutter={[8, 0]}>
                    <Col span={8}>
                      <Form.Item label="Company Name" name="compnayName">
                        <Select options={companyNames} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Policy Number" name="policyNumber">
                        <Input placeholder="Policy Number" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Policy Start Date"
                        name="policyStartDate"
                      >
                        <DatePicker />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Policy Expiration Date"
                        name="policyExpirationDate"
                      >
                        <DatePicker />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <p>Recurring Monthly Charges</p>
              </Col>
              {monthlyCharges.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[12, 0]}>
                      <Col span={6}>
                        <Form.Item
                          label="Amount"
                          name={`amount${index}`}
                          value={item.amount}
                          onChange={(e) => onInputChange(e, item.id, "amount")}
                        >
                          <Input placeholder="0.00" />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="GL Account"
                          name={`gLAccount${index}`}
                        >
                          <TreeSelect
                            placeholder="Select GL Account"
                            treeData={glAccountss}
                            treeDefaultExpandAll
                            value={item.glAccount}
                            onChange={(e) => handleSelectChange(e, item.id)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="Description"
                          name={`description${index}`}
                        >
                          <Input
                            placeholder="Description"
                            value={item.description}
                            onChange={(e) =>
                              onInputChange(e, item.id, "description")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        {monthlyCharges.length > 1 && (
                          <Form.Item label=" ">
                            <button
                              className="close-btn"
                              onClick={() => removeMonthlyCharge(item.id)}
                            >
                              <MdOutlineClose
                                size={32}
                                style={{ color: "#adabab" }}
                              />
                            </button>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addMonthlyCharge()}
                  type="button"
                >
                  <MdAddCircle size={18} />
                  <span>Add Recurring Monthly Charge</span>
                </button>
              </Col>
              <Col span={24}>
                <Form.Item name="propertyPolicy">
                  <Checkbox
                    checked={propertyPolicyChecked}
                    onChange={() =>
                      setPropertyPolicyChecked(!propertyPolicyChecked)
                    }
                  >
                    Use property's policy
                  </Checkbox>
                </Form.Item>
              </Col>
              <Col span={24}>
                <p>Late Fee Policy</p>
              </Col>
              {propertyPolicyChecked ? (
                <Col span={24}>
                  <Row gutter={[10, 16]}>
                    <Col span={12}>
                      <strong>Base Amount</strong>
                      <p>
                        {moveInTenantInfo.propertyUnit.LateFeePolicy
                          .baseLateFeeFlat
                          ? `Flat fee of ${moveInTenantInfo.propertyUnit.LateFeePolicy.baseLateFeeFlat}`
                          : `Late fee of ${moveInTenantInfo.propertyUnit.LateFeePolicy.baseLateFeePercent}%`}
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Daily Amount / Monthly Max</strong>
                      <p>
                        {
                          moveInTenantInfo.propertyUnit.LateFeePolicy
                            .dailyLateFee
                        }{" "}
                        /{" "}
                        {
                          moveInTenantInfo.propertyUnit.LateFeePolicy
                            .maxDailyLateFee
                        }
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Eligible Charges</strong>
                      <p>
                        {
                          moveInTenantInfo.propertyUnit.LateFeePolicy
                            .eligibleCharges
                        }
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Grace Period</strong>
                      <p>
                        {moveInTenantInfo.propertyUnit.LateFeePolicy
                          .gracePeriod === "after"
                          ? `Late fees post after ${moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriodAfterDays} days`
                          : `Late fees post on the ${moveInTenantInfo.propertyUnit.LateFeePolicy.gracePeriodOnday} day of following month`}
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Calculate Fee From</strong>
                      <p>
                        {
                          moveInTenantInfo.propertyUnit.LateFeePolicy
                            .percentFrom
                        }
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Grace Balance</strong>
                      <p>
                        $
                        {
                          moveInTenantInfo.propertyUnit.LateFeePolicy
                            .graceBalance
                        }
                      </p>
                    </Col>
                    <Col span={12}>
                      <strong>Ignore Partial Payments</strong>
                      <p>
                        {moveInTenantInfo.propertyUnit.LateFeePolicy
                          .partialPayments
                          ? "Yes"
                          : "No"}
                      </p>
                    </Col>
                  </Row>
                </Col>
              ) : (
                <Col span={24}>
                  <Row gutter={[10, 16]}>
                    <Col span={12}>
                      <Form.Item label="Late fee type" name="lateFeeType">
                        <Select options={lateFeeType} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Base late fee"
                        required
                        name="baseLateFee"
                        rules={[
                          {
                            required: true,
                            message: "Base late fee is required",
                          },
                        ]}
                      >
                        <Input placeholder="Base late fee" required />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Grace period type"
                        name="gracePeriodType"
                      >
                        <Select options={gracePeriodType} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Grace period value"
                        required
                        name="gracePeriodValue"
                        rules={[
                          {
                            required: true,
                            message: "Grace period value is required",
                          },
                        ]}
                      >
                        <Input placeholder="Grace period value" required />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label="Eligible charge filter type"
                        name="eligibleChargeType"
                      >
                        <Select options={filterType} />
                      </Form.Item>
                    </Col>
                    <Col span={12}></Col>
                    <Col span={12}>
                      <Form.Item
                        name="totalDelinquentBalance"
                        valuePropName="checked"
                      >
                        <Checkbox
                          checked={totalBalanceChecked}
                          onChange={() =>
                            setTotalBalanceChecked(!totalBalanceChecked)
                          }
                        >
                          Use total delinquent balance
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      {totalBalanceChecked ? null : (
                        <Form.Item
                          name="considerPartialPayments"
                          valuePropName="checked"
                        >
                          <Checkbox>Consider partial payments</Checkbox>
                        </Form.Item>
                      )}
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="chargeDailyLateFee"
                        valuePropName="checked"
                      >
                        <Checkbox
                          checked={lateFeeChecked}
                          onChange={() => setLateFeeChecked(!lateFeeChecked)}
                        >
                          Charge daily late fees
                        </Checkbox>
                      </Form.Item>
                    </Col>
                    <Col span={12}></Col>
                    {lateFeeChecked && (
                      <>
                        <Col span={12}>
                          <Form.Item label="Daily late fee" name="dailyLateFee">
                            <Input placeholder="Daily late fee" />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            label="Max daily late fees amount"
                            name="maxDailyLateFee"
                          >
                            <Input placeholder="Max daily late fee amount" />
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    <Col span={12}>
                      <Form.Item label="Grace balance" name="graceBalance">
                        <Input placeholder="Grace balance" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <p>Move In Charges</p>
              </Col>
              {moveInCharges.map((item, index) => {
                return (
                  <Col span={24} key={index}>
                    <Row gutter={[12, 0]}>
                      <Col span={6}>
                        <Form.Item label="Amount">
                          <Input
                            placeholder="Amount"
                            value={item.amount}
                            onChange={(e) =>
                              handleInputChange(e, item.id, "amount")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="GL Account">
                          <TreeSelect
                            placeholder="Select GL Account"
                            treeData={glAccountss}
                            treeDefaultExpandAll
                            value={item.glAccount}
                            onChange={(e) => handleAccountChange(e, item.id)}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item label="Description">
                          <Input
                            placeholder="Description"
                            value={item.description}
                            onChange={(e) =>
                              handleInputChange(e, item.id, "description")
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        {moveInCharges > 1 && (
                          <Form.Item label=" ">
                            <button
                              className="close-btn"
                              onClick={() => removeMoveInCharge(item.id)}
                            >
                              <MdOutlineClose
                                size={32}
                                style={{ color: "#adabab" }}
                              />
                            </button>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>
                  </Col>
                );
              })}
              <Col span={24}>
                <button
                  className="add-icon-btn"
                  onClick={() => addMoveInCharge()}
                  type="button"
                >
                  <MdAddCircle size={18} />
                  <span>Add Move In Charges</span>
                </button>
              </Col>
            </Row>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <Row justify="space-between" align="middle">
                  <Col>
                    <p>Prorated Charges</p>
                  </Col>
                  <Col>
                    {" "}
                    <p className="onclick-text">
                      Prorated Charges What are my proration settings?
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row>
                  {proratedCharges.map((item, index) => {
                    return (
                      <Col span={24} key={index}>
                        <Row>
                          <Col span={24}>
                            <Row gutter={[8, 0]}>
                              <Col span={8}>
                                <Form.Item label="Amount">
                                  <Input
                                    disabled={
                                      item.prorateThisCharge ? false : true
                                    }
                                    placeholder="0.00"
                                    value={item.amount}
                                    onChange={(e) =>
                                      onInputChange(e, item.id, "amount")
                                    }
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item label="GL Account">
                                  <TreeSelect
                                    placeholder="Select GL Account"
                                    treeData={glAccountss}
                                    treeDefaultExpandAll
                                    disabled
                                    value={item.glAccount}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item label="Description">
                                  <Input
                                    placeholder="Description"
                                    value={item.description}
                                    onChange={(e) =>
                                      onInputChange(e, item.id, "description")
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Form.Item name="prorateThisCharge">
                              <Checkbox
                                checked={item.prorateThisCharge}
                                onChange={() => handleCheckboxChange(item.id)}
                              >
                                Prorate this charge
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            <Row gutter={[0, 12]}>
              <Col span={24}>
                <p>
                  Tenant Payment Schedule (Does not include pre-existing
                  charges)
                </p>
              </Col>
              <Col span={24}>
                <Row justify="space-between" className="bordered-row">
                  <Col span={8}>
                    <strong>${moveInChargesSum}</strong>
                    <p>Due Once Move In Completed</p>
                  </Col>
                  <Col span={8} className="inline-border">
                    <strong>${proratedChargesSum}</strong>
                    <p>Due On 03/01/2023</p>
                  </Col>
                  <Col span={8}>
                    <strong>${monthlyChargesSum}</strong>
                    <p>Due Monthly Thereafter</p>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <UsefulMessage message="Deposit charges will be posted upon Continue." />
              </Col>
              <Col span={24}>
                <Row gutter={[8, 0]} justify="end">
                  <Col>
                    <Button type="primary" htmlType="submit">
                      Continue
                    </Button>
                  </Col>
                  <Col>
                    <Button onClick={() => prev()}>Previous</Button>
                  </Col>
                  <Col>
                    <Button type="link" onClick={() => navigate("/")}>
                      Cancel Move In
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default LeaseDetails;
